import React from 'react';

import { Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

interface WorkoutProgramEmptyStateProps {
  isError?: boolean;
}

const WorkoutProgramEmptyState = ({ isError = false }: WorkoutProgramEmptyStateProps): JSX.Element => {
  return (
    <Alert
      icon={<IconAlertCircle size='1rem' />}
      title={isError ? 'Error' : 'Empty Program'}
      color={isError ? 'red' : 'gray'}
    >
      {isError ? 'Something went wrong while fetching program.' : 'Workout program has not been set.'}
    </Alert>
  );
};

export default WorkoutProgramEmptyState;
